import * as React from 'react';
import { getObserver } from './utils';

interface IElementInViewportProps {
  children: JSX.Element;

  onChange(isVisible: boolean): void;
}

export const ElementInViewPort: React.FC<IElementInViewportProps> = ({ children, onChange }) => {
  const detachRef = React.useRef<() => void>(() => {});
  const onChangeRef = React.useRef(onChange);
  onChangeRef.current = onChange;

  const refCallback = React.useCallback((node: HTMLElement | null) => {
    detachRef.current();
    detachRef.current = () => {};

    if (!node) {
      return;
    }

    let isVisible = false;
    const observer = getObserver();

    detachRef.current = observer({
      target: node,
      callback: (visible: boolean) => {
        if (visible !== isVisible) {
          isVisible = visible;
          onChangeRef.current(visible);
        }
      },
    });
  }, []);

  return React.cloneElement(React.Children.only(children), { ref: refCallback });
};
